import {FeatureAppConfigurationModel} from '../../../generated/core';

export function getTrackingId(config: FeatureAppConfigurationModel): string {
    return config.trackingId || config.name;
}
